import {
  Box,
  Button,
  Flex,
  useState
} from '@stars-ecom/shared-atoms-ui'
import React, { useContext, useEffect } from 'react'

import { ShippingContext, UserContext, WebsiteContext } from '../../context'

const ValidateShippingMethod = (props) => {
  const {
    validateShipping: _validateShipping = () => {},
    shippingMethodCode,
    isValid: _isValid,
    isLoading = false,
    shippingMethod = {}
  } = props
  const currentUser = useContext(UserContext)

  const [isValid, setIsValid] = useState(
    _isValid && currentUser.addresses?.length
  )
  const websiteContext = useContext(WebsiteContext)

  const validateShipping = () => {
    _validateShipping()
  }

  useEffect(() => {
    setIsValid(_isValid && currentUser.addresses?.length)
  }, [_isValid])

  return (
    <Flex direction="column">
      <Box textAlign="center" p="20px 0">
        <Button
          id={`validateShippingButtong_${shippingMethodCode}`}
          onClick={validateShipping}
          disabled={!isValid}
          isLoading={isLoading}
          fontFamily={websiteContext.fontFamily}
          fontWeight="normal"
          w={{ base: '100%', md: 'auto' }}
          borderRadius="0"
          h={{ base: 'auto', md: '50px' }}
          p={{ base: '15px', md: '0 32px' }}
          bg={websiteContext.mainColor}
          _hover={{ bg: websiteContext.darkColor }}
          _focus={{ border: 'none' }}
          color="#FFF">
          VALIDER MA LIVRAISON
        </Button>
      </Box>
    </Flex>
  )
}

export default ValidateShippingMethod
